<app-settings-base
  title="{{'signhostSettings.title' | translate}}"
  description="{{'signhostSettings.text' | translate}}"
  details="{{'signhostSettings.detailsHeader' | translate}}"
  sourceUrl="/setting/signhost">
</app-settings-base>
